// EXTERNAL IMPORTS
import React, { Component } from "react";
import PropTypes from "prop-types";
import classnames from "classnames";
import { connect } from "react-redux";
import { themr } from "react-css-themr";
import { Redirect } from "react-router-dom";
import { withRouter } from "react-router";
import { Button } from "@lifepay/rc-ui-toolkit";
import { Lock } from "@lifepay/redux-subsystem-access";

// ABSOLUTE PATH IMPORTS
// importing object with action creator functions
import { LOCK_KEYS } from "accessConfig";
import actions from "model/actions";
import selectors from "model/selectors";

// RELATIVE PATH IMPORTS
// importing default component styles
import styles from "./Menu.m.scss";

@withRouter
// connecting component to the redux store
@connect(
  // mapStateToProps function - passes data from store's state.
  (state) => {
    return {
      selectedCompany: selectors.clients.selectedCompany$$(state),
      selectedPerson: selectors.clients.selectedPerson$$(state),
    };
  },
  // mapDispatchToProps object - pass individual action creators here
  {
    deselectClient: actions.clients.deselectClient,
    removeClient: actions.clients.removeClient,
  }
)
@themr("client-menu", styles)
export default class Menu extends Component {
  // declaring props passed to the component
  static propTypes = {
    theme: PropTypes.object,
    history: PropTypes.object,
    match: PropTypes.object,
    basePath: PropTypes.string,
    deselectClient: PropTypes.func,
    removeClient: PropTypes.func,
    location: PropTypes.object,
  };

  render() {
    const {
      theme,
      history,
      basePath,
      match,
      deselectClient,
      removeClient,
    } = this.props;

    if (!match.params.clientId) {
      return <Redirect to={`${basePath}/search`} />;
    }
    const client = match.params.clientId.split("-");
    let clientType = null;
    switch (client[0]) {
      case "c": {
        clientType = "COMPANY";
        break;
      }
      case "p": {
        clientType = "PERSON";
        break;
      }
      default: {
        return <Redirect to={`${basePath}/search`} />;
      }
    }
    const clientId = match.params.clientId;
    if (!clientId) {
      return <Redirect to={`${basePath}/search`} />;
    }

    return (
      <div className={classnames(theme.wrapper)}>
        <div className={classnames(theme.content)}>
          <div className={classnames(theme.block)}>
            {clientType === "PERSON" ? (
              <Lock
                lockId={LOCK_KEYS.FINANCIAL_INFO_INDIVIDUALS}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button
                  type={"alt"}
                  size={"medium"}
                  onClick={() => {
                    history.push(
                      `${basePath}/${match.params.clientId}/emission`
                    );
                  }} // stub
                >
                  {"Эмиссия"}
                </Button>
              </Lock>
            ) : null}
            {clientType === "COMPANY" ? (
              <Lock
                lockId={LOCK_KEYS.FINANCIAL_INFO_COMPANIES}
                type={"lock"}
                theme={{
                  wrapper: theme.button,
                }}
              >
                <Button
                  type={"alt"}
                  size={"medium"}
                  onClick={() => {
                    history.push(
                      `${basePath}/${match.params.clientId}/acquiring`
                    );
                  }} // stub
                >
                  {"Эквайринг"}
                </Button>
              </Lock>
            ) : null}
          </div>
          <div className={classnames(theme.block)}>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                history.push(`${basePath}/${match.params.clientId}/info`);
              }}
            >
              {"Информация о клиенте"}
            </Button>
            <Button
              type={"disabled"}
              disabled
              size={"medium"}
              onClick={() => {}} // stub
            >
              {"Подключение новой услуги"}
            </Button>
          </div>
          <div className={classnames(theme.block)}>
            <Button
              type={"disabled"}
              disabled
              size={"medium"}
              onClick={() => {}} // stub
            >
              {"Перезвонить клиенту"}
            </Button>
            <Button
              type={"disabled"}
              disabled
              size={"medium"}
              onClick={() => {}} // stub
            >
              {"Запланировать обратный звонок"}
            </Button>
            <Button
              type={"disabled"}
              disabled
              size={"medium"}
              onClick={() => {}} // stub
            >
              {"Запланировать выезд к клиенту"}
            </Button>
          </div>
          <div className={classnames(theme.block)}>
            <Lock
              lockId={LOCK_KEYS.CLIENT_ISSUES}
              type={"lock"}
              theme={{
                wrapper: theme.button,
              }}
            >
              <Button
                type={"alt"}
                size={"medium"}
                onClick={() => {
                  history.push(
                    `${basePath}/${match.params.clientId}/support-request`
                  );
                }}
              >
                {"Другая проблема"}
              </Button>
            </Lock>
          </div>
          <div className={classnames(theme.block)}>
            <Button
              type={"alt"}
              size={"medium"}
              onClick={() => {
                deselectClient({ id: clientId, type: clientType });
                history.push(`${basePath}/search`);
              }}
            >
              {"Вернуться к поиску"}
            </Button>
            <Button
              type={"main"}
              size={"medium"}
              onClick={() => {
                removeClient({ id: clientId, type: clientType });
                history.push(`${basePath}/search`);
              }}
            >
              {"Завершить работу с клиентом"}
            </Button>
          </div>
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/containers/Private/pages/workflow-client/Menu/Menu.js